(function(){

  function getStock(){
    const el = document.querySelector('[data-js-variant-quantity]');
    if (!el) return null;
    return el.dataset.stock;
  }

  function updateMessage(stock){
    const msg = document.querySelector('[data-oos-message]');
    if (!msg) return;
    msg.style.display = (stock === 'pre-order') ? 'block' : 'none';
  }

  function init(){
    setTimeout(function(){
      const stock = getStock();
      if (stock !== null) updateMessage(stock);
    }, 300);

    document.addEventListener('krown:variant:change', function(){
      setTimeout(function(){
        const stock = getStock();
        if (stock !== null) updateMessage(stock);
      }, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
